(ns dre.components.search-results.db
  (:require
   [dre.config :as config]
   [dre.i18n.utils :refer [tr-later]]))


(defn order-options
  []
  (remove nil? [{:id :scoretitle-desc
                 :label (tr-later "Best title match (descending ↓)")}
                #_{:id :scorenew-desc
                   :label (tr-later "Best match (descending ↓)")}
                (when (config/admin-role?)
                  {:id :score-asc
                   :label (tr-later "Best match (ascending ↑)")})
                {:id :new-desc
                 :label (tr-later "New items (descending ↓)")}
                {:id :published-desc
                 :label (tr-later "Published date (descending ↓)")}
                {:id :published-asc
                 :label (tr-later "Published date (ascending ↑)")}
                (when (config/feature-enabled? :question-answering)
                  {:id :ai-sum
                   :label (tr-later "AI Summarization articles prioritized")})
                #_{:id :changed-desc
                   :label (tr-later "Changed date (descending ↓)")}
                #_{:id :changed-asc
                   :label (tr-later "Changed date (ascending ↑)")}]))


(defn order-options-index
  []
  (into {} (map (juxt :id identity)) (order-options)))

(def default-order :scoretitle-desc)

(def default-limit 15)

(def default-offset 0)
